import { PolicyCategory, PolicyCategoryMeta, PolicyDefinition } from "./policyTypes";
import { polCore } from "./polCore";
import { polSafeguarding } from "./polSafeguarding";
import { polHealthSafety } from "./polHealthSafety";
import { polClinical } from "./polClinical";
import { polPeople } from "./polPeople";
import { polGov } from "./polGov";
import { polUpdated } from "./polUpdated";

export const policyCategories: PolicyCategoryMeta[] = [
  {
    id: "core",
    label: "Core",
    shortLabel: "Core",
    description: "Registration, records, consent, confidentiality and openness.",
  },
  {
    id: "safeguarding",
    label: "Safeguarding",
    shortLabel: "Safeguarding",
    description: "Protection from abuse, neglect, exploitation and harm.",
  },
  {
    id: "health-safety",
    label: "Health and Safety",
    shortLabel: "Health and Safety",
    description: "Environment, fire, infection, equipment and site safety.",
  },
  {
    id: "clinical",
    label: "Clinical",
    shortLabel: "Clinical",
    description: "Medicines, skin, falls, diabetes and end of life care.",
  },
  {
    id: "people",
    label: "People",
    shortLabel: "People",
    description: "Dignity, choice, communication, activities and family support.",
  },
  {
    id: "environment",
    label: "Environment and Premises",
    shortLabel: "Environment",
    description: "Premises safety, fire, water safety, equipment and the built environment.",
  },
  {
    id: "governance",
    label: "Governance",
    shortLabel: "Governance",
    description: "Audits, incidents, staffing, recruitment and provider oversight.",
  },
];

export const allPolicies: PolicyDefinition[] = [
  ...polCore,
  ...polSafeguarding,
  ...polHealthSafety,
  ...polClinical,
  ...polPeople,
  ...polGov,
  ...polUpdated,
];

export const policyLibrary = {
  categories: policyCategories,
  policies: allPolicies,
};

export function getPoliciesByCategory(category: PolicyCategory): PolicyDefinition[] {
  return allPolicies.filter(policy => policy.category === category);
}

export function getPolicyById(id: string): PolicyDefinition | undefined {
  return allPolicies.find(policy => policy.id === id);
}

export function countPoliciesByCategory(category: PolicyCategory): number {
  return getPoliciesByCategory(category).length;
}

export function getPolicySearchText(policy: PolicyDefinition): string {
  return [
    policy.code,
    policy.title,
    policy.summary,
    policy.cqcFocus,
    ...policy.keyPoints,
  ]
    .join(" ")
    .toLowerCase();
}

export function searchPolicies(query: string): PolicyDefinition[] {
  const q = query.trim().toLowerCase();

  if (!q) {
    return allPolicies;
  }

  return allPolicies.filter(policy => getPolicySearchText(policy).includes(q));
}